import {Component, EventEmitter, Injector, Input, Output} from '@angular/core';
import {ControllerComponent} from '../../Controller/controller-component';
import {NumberUtils} from '../../../Shared/Utils/number.utils';

@Component({
  selector: 'app-counter-input',
  templateUrl: './counter-input.component.html',
  styleUrls: ['./counter-input.component.scss'],
  standalone: false
})
export class CounterInputComponent extends ControllerComponent {

  @Input() value: number = 0;

  @Input() min: number | null = null;
  @Input() max: number | null = null;
  @Input() multiple: number | null = null;

  @Input() addText: string = 'COMMON.ADD';

  @Input() readonly: boolean = false;
  @Input() zeroIsValid: boolean = false;
  @Input() onlyNegative: boolean = false;

  @Output() valueChange: EventEmitter<number> = new EventEmitter<number>();

  constructor(
    protected override injector: Injector
  ) {
    super(injector);
  }


  /**
   * Hacer acción
   *
   */
  public doAction(quantity?: number) {

    this.hapticsImpactManager.hapticsImpactMedium();

    if (quantity) {
      this.setQuantity(quantity);
      return;
    }

    this.setQuantityManual();
  }


  /**
   * Establecer manualmente la cantidad
   *
   */
  private async setQuantityManual() {
    const alert = await this.alertCtrl.create({
      enterAnimation: this.animationCtrl.showAlertAnimation,
      leaveAnimation: this.animationCtrl.hideAlertAnimation,
      header: this.translate.instant('COMMON.FIELDS.QUANTITY_LABEL'),
      inputs: [
        {
          name: 'quantity',
          placeholder: this.translate.instant('COMPONENTS.COUNTER_INPUT.QUANTITY_PLACEHOLDER'),
          type: 'number',
          value: this.value,
        },
      ],
      buttons: [
        {
          text: this.translate.instant('COMMON.CANCEL'),
          role: 'cancel'
        },
        {
          text: this.translate.instant('COMMON.SAVE'),
          role: 'destructive',
          handler: (data) => {

            const quantity: number = NumberUtils.replacePoint(data.quantity);

            if (!quantity && quantity !== 0) {
              this.toastCtrl.showWarningToast(this.translate.instant('COMPONENTS.COUNTER_INPUT.INVALID_NUMBER'));
              return;
            }

            this.value = quantity;
            this.setQuantity(0, false);
          }

        }]
    });

    await alert.present();
  }


  /**
   * Establecer la cantidad
   *
   */
  private setQuantity(quantity: number, applyMultiplier: boolean = true) {

    if (this.multiple && applyMultiplier) {
      quantity = quantity > 0 ? this.multiple : -this.multiple;
    }

    let newQuantity: number = this.value + quantity;

    newQuantity = this.checkMaximumValue(newQuantity);
    newQuantity = this.checkMinimumValue(newQuantity);

    this.value = NumberUtils.formatNumber(newQuantity);
    this.valueChange.emit(this.value);
  }


  /**
   * Comprobar el valor máximo permitido
   *
   */
  private checkMaximumValue(value: number): number {

    if (!this.max || this.onlyNegative) {
      return value;
    }

    const maximumValue: number = this.multiple ? this.max * this.multiple : this.max;

    if (value > maximumValue) {
      this.toastCtrl.showInfoToast(this.translate.instant('COMPONENTS.COUNTER_INPUT.MAX_NUMBER'));
      return maximumValue;
    }

    return value;
  }


  /**
   * Comprobar el valor mínimo permitido
   *
   */
  private checkMinimumValue(value: number): number {

    if (!this.min || this.onlyNegative) {
      return value;
    }

    const minimumValue: number = this.multiple ? this.min * this.multiple : this.min;

    if (value < minimumValue) {
      this.toastCtrl.showInfoToast(this.translate.instant('COMPONENTS.COUNTER_INPUT.MIN_NUMBER', {min: this.min}));
      return minimumValue;
    }

    return value;
  }

}
